import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page-hero mb-4 mb-md-5"
};
const _hoisted_2 = {
  class: "page-subtitle"
};
const _hoisted_3 = {
  key: 0,
  class: "faq-grid"
};
const _hoisted_4 = {
  class: "faq-list"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "faq-grid"
};
const _hoisted_10 = {
  class: "faq-card-title"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  key: 2,
  class: "faq-grid"
};
const _hoisted_13 = {
  class: "faq-card-title"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  key: 3,
  class: "faq-grid"
};
const _hoisted_16 = {
  class: "faq-card-title"
};
const _hoisted_17 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_container = _resolveComponent("b-container");
  return $data.networkInfo && $data.groupnum ? (_openBlock(), _createBlock(_component_b_container, {
    key: 0,
    class: "faq-page py-4 py-md-5",
    role: "region",
    "aria-label": "faq"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_row, {
      class: "justify-content-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "12",
        xl: "10"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("h1", {
          id: "main-title",
          class: "page-title"
        }, " FAQ ", -1)), _createElementVNode("p", _hoisted_2, " Find answers to common questions about subscriptions, uploads, channels, and access for " + _toDisplayString($data.networkInfo.name || 'your network') + ". ", 1)]), $data.groupnum == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_b_card, {
          class: "faq-card"
        }, {
          header: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("h3", {
            class: "faq-card-title"
          }, " HOW DO SUBSCRIPTIONS WORK ON YOUR VIDEO NETWORK? ", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("p", null, " There are different subscription options depending on the network. ", -1)), _createElementVNode("ul", _hoisted_4, [$data.monthlyfee ? (_openBlock(), _createElementBlock("li", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("strong", null, "Month to month:", -1)), _createTextVNode(" The subscriber pays $" + _toDisplayString($data.monthlyfee) + " monthly. This subscription can be cancelled at any time and renews monthly. ", 1)])) : _createCommentVNode("", true), $data.yearlyfee ? (_openBlock(), _createElementBlock("li", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("strong", null, "Yearly:", -1)), _createTextVNode(" The subscriber pays $" + _toDisplayString($data.yearlyfee) + " for one year of access. This subscription can be cancelled at any time and renews annually. ", 1)])) : _createCommentVNode("", true), $data.eventfee ? (_openBlock(), _createElementBlock("li", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("strong", null, "Event:", -1)), _createTextVNode(" The subscriber pays $" + _toDisplayString($data.eventfee) + " for access for " + _toDisplayString($data.duration) + " day", 1), $data.duration > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "s")) : _createCommentVNode("", true), _cache[5] || (_cache[5] = _createTextVNode(". This is usually for a special event and does not auto-renew. ", -1))])) : _createCommentVNode("", true)]), _cache[7] || (_cache[7] = _createElementVNode("p", null, " These subscriptions give access to live streams and on-demand video content. ", -1)), _cache[8] || (_cache[8] = _createElementVNode("p", null, [_createTextVNode(" To cancel, log in and go to the "), _createElementVNode("strong", null, "My Subscription"), _createTextVNode(" page, then select "), _createElementVNode("strong", null, "Cancel My Subscription"), _createTextVNode(". ")], -1))], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        }), _createVNode(_component_b_card, {
          class: "faq-card"
        }, {
          header: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("h3", {
            class: "faq-card-title"
          }, "CAN MY FAMILY SHARE ONE SUBSCRIPTION?", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("p", null, " Immediate family members who live in the same house can share one subscription, such as spouses, students, and siblings. ", -1), _createElementVNode("p", null, " Grandparents, aunts, uncles, and family friends should purchase their own subscription. ", -1)]))], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        }), _createVNode(_component_b_card, {
          class: "faq-card"
        }, {
          header: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("h3", {
            class: "faq-card-title"
          }, " HOW LONG DOES IT TAKE FOR A VIDEO TO BE VIEWABLE ONCE IT HAS BEEN UPLOADED? ", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createElementVNode("p", null, " In most cases, videos are available almost immediately after upload. ", -1)]))], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })])) : _createCommentVNode("", true), $data.groupnum == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.faqGroup2, (item, index) => {
          return _openBlock(), _createBlock(_component_b_card, {
            class: "faq-card",
            key: 'g2-' + index
          }, {
            header: _withCtx(() => [_createElementVNode("h3", _hoisted_10, _toDisplayString(item.title), 1)]),
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createElementVNode("p", {
                innerHTML: item.text
              }, null, 8, _hoisted_11)], undefined, true),
              _: 2
            }, 1024)], undefined, true),
            _: 2
          }, 1024);
        }), 128))])) : _createCommentVNode("", true), $data.groupnum == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.faqGroup3, (item, index) => {
          return _openBlock(), _createBlock(_component_b_card, {
            class: "faq-card",
            key: 'g3-' + index
          }, {
            header: _withCtx(() => [_createElementVNode("h3", _hoisted_13, _toDisplayString(item.title), 1)]),
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createElementVNode("p", {
                innerHTML: item.text
              }, null, 8, _hoisted_14)], undefined, true),
              _: 2
            }, 1024)], undefined, true),
            _: 2
          }, 1024);
        }), 128))])) : _createCommentVNode("", true), $data.groupnum == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.faqGroup4, (item, index) => {
          return _openBlock(), _createBlock(_component_b_card, {
            class: "faq-card",
            key: 'g4-' + index
          }, {
            header: _withCtx(() => [_createElementVNode("h3", _hoisted_16, _toDisplayString(item.title), 1)]),
            default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [_createElementVNode("p", {
                innerHTML: item.text
              }, null, 8, _hoisted_17)], undefined, true),
              _: 2
            }, 1024)], undefined, true),
            _: 2
          }, 1024);
        }), 128))])) : _createCommentVNode("", true)], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true);
}